import React, { useEffect } from "react";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { Button, TablePagination, ToggleButton } from "@mui/material";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import { useState } from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import createInstance from "../../../api/axiosinstance";
import Toast from "../../../utils/toast";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? " #1A2027" : "#fff",
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
}));
const CssTextField = styled(TextField)({
  "& label": {
    color: "#033538",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#033538",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#033538",
      borderRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: "#033538",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#033538",
    },
    "& .MuiInputBase-input": {
      // Add this line
      color: "#033538", // Change the color here
    },
  },
});

const CssFormControl = styled(FormControl)({
  "& label": {
    color: "#033538",
    "&.Mui-focused": {
      color: "#033538",
    },
  },
  "& .MuiInputBase-root": {
    color: "#033538",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#033538",
      borderRadius: 10,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#033538",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#033538",
    },
  },
});

const CssSelect = styled(Select)({
  "& .MuiSvgIcon-root": {
    color: "#033538",
    textAlign: "center",
  },
});

const JobDescription = () => {
  const aiDishaApi = createInstance("DISHA");
  const [jobTitle, setJobTitle] = useState("");
  const [yearsOfExpList, setYearsOfExpList] = useState([]);
  const [yearsOfExperience, setYearsOfExperience] = useState("");
  const [activeCities, setActiveCities] = useState([]);
  const [city, setCity] = useState("");
  const [state, setState] = useState("");
  const [salaryRangeList, setSalaryRangeList] = useState([]);
  const [salaryRange, setSalaryRange] = useState("");
  const [employeeType, setEmployeeType] = useState("");
  const [jobDescription, setJobDescription] = useState("");
  const [responsibility, setResponsibility] = useState("");
  const [activeSkills, setActiveSkills] = useState([]);
  const [requiredSkills, setRequiredSkills] = useState([]);
  const [additionalSkills, setAdditionalSkills] = useState("");
  const [functionalArea, setFunctionalArea] = useState("");
  const [designations, setDesignations] = useState([]);
  const [designation, setDesignation] = useState("");
  const [aboutCompany, setAboutCompany] = useState("");
  const [educationDetails, setEducationDetails] = useState([]);
  const [educationDetailsUg, setEducationDetailsUg] = useState([]);
  const [educationDetailsPg, setEducationDetailsPg] = useState([]);
  const [benefits, setBenefits] = useState("");
  const [isOthersUg, setIsOthersUg] = useState(false);
  const [isOthersPg, setIsOthersPg] = useState(false);
  const [ugDegree, setUgDegree] = useState("");
  const [pgDegree, setPgDegree] = useState("");
  const organizationId = window.sessionStorage.getItem("organizationId");
  console.log("ORGID" + organizationId);

  //const [allDropdownValues, setAllDropdownValues] = useState({});

  useEffect(() => {
    getActiveCities();
    getActiveSkills();
    getUgDetails();
    getPgDetails();
    getAllDropdownValues();
  }, []);

  const getAllDropdownValues = async () => {
    await aiDishaApi
      .get("/job_all_dropdown")
      .then((response) => {
        const values = response.data;
        setYearsOfExpList(values["experience_yrs"]);
        setSalaryRangeList(values["salary_range"]);
        setDesignations(values["designation"]);
        console.log(response.data);
      })
      .catch((error) => {
        console.error(
          "Error fetching the list of values for the drop downs",
          error
        );
      });
  };

  //To Fetch all the 'Active' cities (irrespective of the state or district)
  const getActiveCities = async () => {
    await aiDishaApi
      .get("/Cities/active")
      .then((response) => {
        setActiveCities(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching active cities" + error);
      });
  };

  //To get the State Name corresponding to the city selected by the user
  const getStateName = async (city) => {
    setCity(city);
    await aiDishaApi
      .get(`/statenames_based_on_city?city=${city}`)
      .then((response) => {
        response.data.state ? setState(response.data.state) : setState("");
        console.log("State is *********" + response.data.state);
      })
      .catch((error) => {
        console.error("Error fetching state name for the given city", error);
      });
  };

  // To get all 'active' skills from Skill table
  const getActiveSkills = async () => {
    await aiDishaApi
      .get("/skills-show/active")
      .then((response) => {
        const skillData = response.data;
        setActiveSkills(skillData);
        console.log("skills values" ,skillData);
        const skillNames = skillData.map(skill => skill.skill_name);
        console.log("All Skill Names:", skillNames);
      })
      .catch((error) => {
        console.error("Error fetching active skills" + error);
      });
  };

  const getUgDetails = async () => {
    // setEducationDetailsUg(["B.E. Computer Science", "B.Sc.Computer Science", "B.E.
    //Information Technology","Others(b)"]);
    await aiDishaApi
      .get("/undergraduate_degrees")
      .then((response) => {
        setEducationDetailsUg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching UG details" + error);
      });
  };

  const getPgDetails = async () => {
    //setEducationDetailsPg(["M.E. Computer Science", "M.Sc.Computer Science", "M.E.
    //Information Technology","Others(m)"]);
    await aiDishaApi
      .get("/postgraduate_degrees")
      .then((response) => {
        setEducationDetailsPg(response.data);
        console.log(response.data);
      })
      .catch((error) => {
        console.error("Error fetching PG details" + error);
      });
  };

  const setEduDetails = (event) => {
    console.log(event);
    setEducationDetails(event);
    //validateEdu(event);

    setIsOthersUg(event.includes("Others(UG)") ? true : false);
    setIsOthersUg(event.includes("Others(UG)") ? true : false);

    setIsOthersPg(event.includes("Others(PG)") ? true : false);
    setIsOthersPg(event.includes("Others(PG)") ? true : false);

    console.log("UG others ? " + isOthersUg);
    console.log("PG others ? " + isOthersPg);
  };

  const saveJobDetails = async (event) => {
    event.preventDefault();

    if (!jobTitle.trim()) {
      console.error("Job title cannot be empty");
      Toast.error("Job title cannot be empty");
      return;
    }

    if (!yearsOfExperience.trim()) {
      console.error("Experience cannot be empty");
      Toast.error("Experience cannot be empty");
      return;
    }

    if (!city.trim()) {
      console.error("City cannot be empty");
      Toast.error("City cannot be empty");
      return;
    }

    if (!salaryRange.trim()) {
      console.error("Salary Range be empty");
      Toast.error("Salary Range cannot be empty");
      return;
    }

    if (!employeeType.trim()) {
      console.error("Employee Type be empty");
      Toast.error("Employee Type cannot be empty");
      return;
    }

    if (!jobDescription.trim()) {
      console.error("Job Description be empty");
      Toast.error("Job Description cannot be empty");
      return;
    }
    if (!responsibility.trim()) {
      console.error("Responsibility be empty");
      Toast.error("Responsibility cannot be empty");
      return;
    }

    if (requiredSkills.length === 0) {
      console.error("Required Skills cannot be empty");
      Toast.error("Required Skills cannot be empty");
      return;
    }

    if (!aboutCompany.trim()) {
      console.error("Company details cannot be empty");
      Toast.error("Company details cannot be empty");
      return;
    }

    if (!designation.trim()) {
      console.error("Designation cannot be empty");
      Toast.error("Designation cannot be empty");
      return;
    }

    if (educationDetails.length === 0) {
      console.error("Educational Details cannot be empty");
      Toast.error("Educational Details cannot be empty");
      return;
    }

    if (isOthersUg && !ugDegree.trim()) {
      console.error("UG Details cannot be empty");
      Toast.error("UG Details cannot be empty");
      return;
    }

    if (isOthersPg && !pgDegree.trim()) {
      console.error("PG Details cannot be empty");
      Toast.error("PG Details cannot be empty");
      return;
    }

    if (isOthersUg || isOthersPg) {
      var ugIndex = educationDetails.indexOf("Others(UG)");
      var pgIndex = educationDetails.indexOf("Others(UG)");
      educationDetails.splice(ugIndex, 1);
      educationDetails.splice(pgIndex, 1);

      educationDetails.push(ugDegree);
      educationDetails.push(pgDegree);
    }

    console.log(
      "Title = " +
        jobTitle +
        "\n Exp = " +
        yearsOfExperience +
        "\n city = " +
        city +
        "\n state = " +
        state +
        "\n salary = " +
        salaryRange +
        "\n etype = " +
        employeeType +
        "\n jobdesc = " +
        jobDescription +
        "\n resp = " +
        responsibility +
        "\n req skills = " +
        requiredSkills +
        "\n add skills = " +
        additionalSkills +
        "\n funcArea = " +
        functionalArea +
        "\n designation = " +
        designation +
        "\n abt comp = " +
        aboutCompany +
        "\n benifits = " +
        benefits +
        "\n edu details = " +
        educationDetails +
        "\n ugDegree = " +
        ugDegree +
        "\n pgDegree = " +
        pgDegree
    );

    await aiDishaApi
      .post(
        "/org-insert-job/",
        {
          org_id: organizationId,
          job_title: jobTitle,
          job_description: jobDescription,
          company_info: aboutCompany,
          responsibility: responsibility,
          status: "Active",
          additional_skills: additionalSkills,
          benefits: benefits,
        },
        {
          params: {
            Education_Details: educationDetails,
            Functional_area: functionalArea,
            Required_Skills: requiredSkills,
            city: city,
            designation: designation,
            emp_type: employeeType,
            experience_yrs: yearsOfExperience,
            salary_range: salaryRange,
            state: state,
          },
          paramsSerializer: {
            indexes: null,
          },
        }
      )
      .then((response) => {
        console.log(response.data);
        clearForm();
        Toast.success("Job created successfully");
      })
      .catch((error) => {
        console.error("Error creating job", error);
      });
  };

  const clearForm = () => {
    setJobTitle("");
    setYearsOfExperience("");
    setCity("");
    setState("");
    setSalaryRange("");
    setEmployeeType("");
    setJobDescription("");
    setResponsibility("");
    setRequiredSkills([]);
    setAdditionalSkills("");
    setFunctionalArea("");
    setDesignation("");
    setAboutCompany("");
    setBenefits("");
    setEducationDetails([]);
  };

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin", // For Firefox
        msOverflowStyle: "none", // For Internet Explorer
        scrollbarColor: "transparent transparent", // For Firefox
        "&::-webkit-scrollbar": {
          width: "5px", // Width of the scrollbar
          height: "5px",
        },
      }} // Height of the scrollbar
    >
      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 10%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{
              fontFamily: "poppins",
              fontSize: "28px",
              color: "#033538",
              mb: "2%",
            }}
          >
            Add New Job
          </Typography>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Job Title<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            label="Enter Job Title"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={jobTitle}
            onChange={(e) => setJobTitle(e.target.value)}
            required={true}
            disabled={false}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Experience(in Years)<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#FFFFFF" }}>
            <InputLabel>Select Experience</InputLabel>
            <CssSelect
              label="Experience"
              id="demo-simple-select-outlined"
              size="small"
              value={yearsOfExperience}
              onChange={(e) => setYearsOfExperience(e.target.value)}
              sx={{ width: "100%", textAlign: "center" }}
              required={true}
              disabled={false}
            >
              <MenuItem
                key="yearsOfExp"
                value="yearsOfExp"
                disabled={true}
                sx={{ color: "black", }}
              >
                Select Experience
              </MenuItem>
              {yearsOfExpList.map((exp) => (
                <MenuItem
                  key={exp}
                  value={exp}
                  sx={{ color: "black", }}
                >
                  {exp}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            City<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select city</InputLabel>
            <CssSelect
              label="City"
              id="demo-simple-select-outlined"
              size="small"
              value={city}
              onChange={(e) => getStateName(e.target.value)}
              sx={{ width: "100%", textAlign: "center" }}
            >
              {activeCities.map((city) => (
                <MenuItem
                  key={city.city_name}
                  value={city.city_name}
                  sx={{ color: "black",  }}
                >
                  {city.city_name}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            State
          </Typography>

          <CssTextField
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={state}
            disabled={true}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Salary Range<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Salary Range</InputLabel>
            <CssSelect
              label="Salary Range"
              id="demo-simple-select-outlined"
              size="small"
              value={salaryRange}
              onChange={(e) => setSalaryRange(e.target.value)}
              sx={{ width: "100%", textAlign: "center" }}
              required={true}
              disabled={false}
            >
              <MenuItem
                key="salaryrange"
                value="salaryRange"
                disabled={true}
                sx={{ color: "black",  }}
              >
                Select Salary Range
              </MenuItem>
              {salaryRangeList.map((sal) => (
                <MenuItem
                  key={sal}
                  value={sal}
                  sx={{ color: "black",  }}
                >
                  {sal}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Employee Type<span style={{ color: "red" }}>*</span>
          </Typography>

          <ToggleButtonGroup color="primary" value={employeeType} exclusive>
            <ToggleButton
              style={{
                border: "1px solid",
                borderColor: "#B9B9B9",
                borderRadius: "10px",
                color: "#033538",
                fontFamily: "poppins",
                fontSize: "12px",
              }}
              value="Full Time"
              selectedColor="#123445"
              onClick={(e) => setEmployeeType(e.target.value)}
            >
              Full Time
            </ToggleButton>
            <ToggleButton
              selectedColor="#FFFFFF"
              style={{
                border: "1px solid",
                borderColor: "#B9B9B9",
                borderRadius: "10px",
                color: "#033538",
                fontFamily: "poppins",
                fontSize: "12px",
              }}
              value="Part Time"
              onClick={(e) => setEmployeeType(e.target.value)}
            >
              Part Time
            </ToggleButton>
            <ToggleButton
              selectedColor="#FFFFFF"
              style={{
                border: "1px solid",
                borderColor: "#B9B9B9",
                borderRadius: "10px",
                color: "#033538",
                fontFamily: "poppins",
                fontSize: "12px",
              }}
              value="Contract"
              onClick={(e) => setEmployeeType(e.target.value)}
            >
              Contract
            </ToggleButton>
            <ToggleButton
              selectedColor="#FFFFFF"
              style={{
                border: "1px solid",
                borderColor: "#B9B9B9",
                borderRadius: "10px",
                color: "#033538",
                fontFamily: "poppins",
                fontSize: "12px",
              }}
              value="Internship"
              onClick={(e) => setEmployeeType(e.target.value)}
            >
              Internship
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Job Description
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Job Description"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%" }}
            value={jobDescription}
            onChange={(e) => setJobDescription(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", width: "90%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Responsibility
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Responsibilities"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%" }}
            value={responsibility}
            onChange={(e) => setResponsibility(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Required Skills
            <span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Skills</InputLabel>
            <CssSelect
              multiple={true}
              label="Select Type of Sector"
              id="demo-simple-select-outlined"
              size="small"
              sx={{ width: "100%", textAlign: "center", mb: "2%" }}
              value={requiredSkills}
              onChange={(e) => setRequiredSkills(e.target.value)}
            >
              {(activeSkills || []).map((skill, index) => (
                <MenuItem
                  key={skill.skill_name}
                  value={skill.skill_name}
                  sx={{ color: "black",  }}
                >
                  {skill.skill_name}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Additional Skills
          </Typography>
          <CssTextField
            label="Enter Additional Skills"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={additionalSkills}
            onChange={(e) => setAdditionalSkills(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Functional Area
          </Typography>
          <CssTextField
            label="Enter Functional Area"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={functionalArea}
            onChange={(e) => setFunctionalArea(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Designation<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Designation</InputLabel>
            <CssSelect
              label="Select Role"
              id="demo-simple-select-outlined"
              size="small"
              sx={{ width: "100%", textAlign: "center", mb: "2%" }}
              value={designation}
              onChange={(e) => setDesignation(e.target.value)}
            >
              <MenuItem
                key="designation"
                value="designation"
                disabled={true}
                sx={{ color: "black" }}
              >
                Select Designation
              </MenuItem>
              {designations.map((desig) => (
                <MenuItem
                  key={desig}
                  value={desig}
                  sx={{ color: "black", }}
                >
                  {desig}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            About the Company<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter details about the company"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%" }}
            value={aboutCompany}
            onChange={(e) => setAboutCompany(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{
            marginTop: "auto",
            textAlign: "left",
            width: "90%",
            marginBottom: "2%",
          }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Benefits
          </Typography>
          <CssTextField
            id="outlined-multiline-flexible"
            label="Enter Benefits"
            multiline
            rows={2}
            sx={{ width: "100%", mb: "2%" }}
            value={benefits}
            onChange={(e) => setBenefits(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Education<span style={{ color: "red" }}>*</span>
          </Typography>
          <CssFormControl sx={{ width: "90%" }}>
            <InputLabel>Select Education Details</InputLabel>
            <CssSelect
              multiple={true}
              label="Select education details"
              id="demo-simple-select-outlined"
              size="small"
              sx={{ width: "100%", textAlign: "center", mb: "2%" }}
              value={educationDetails}
              onChange={(e) => setEduDetails(e.target.value)}
            >
              <MenuItem
                color="black"
                key="ug"
                value="ug"
                disabled={true}
                sx={{ color: "white", backgroundColor: "#033538" }}
              >
                Under Graduate
              </MenuItem>
              {educationDetailsUg.map((degreeUg) => (
                <MenuItem
                  key={degreeUg}
                  value={degreeUg}
                  sx={{ color: "black", }}
                >
                  {degreeUg}
                </MenuItem>
              ))}
              <MenuItem
                key="pg"
                value="pg"
                disabled={true}
                sx={{ color: "white", backgroundColor: "#033538" }}
              >
                Post Graduate
              </MenuItem>
              {educationDetailsPg.map((degreePg) => (
                <MenuItem
                  key={degreePg}
                  value={degreePg}
                  sx={{ color: "black",  }}
                >
                  {degreePg}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          display={isOthersUg === true ? "block" : "none"}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Educational Details (UG)
          </Typography>
          <CssTextField
            label="Enter UG Educational Details"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={ugDegree}
            onChange={(e) => setUgDegree(e.target.value)}
          />
        </Box>

        <br />
        <br />

        <Box
          gridColumn="span 6"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "2%" }}
          display={isOthersPg === true ? "block" : "none"}
        >
          <Typography
            sx={{ fontFamily: "poppins", color: "#033538", textAlign: "left" }}
          >
            Educational Details (PG)
          </Typography>
          <CssTextField
            label="Enter PG Educational Details"
            id="custom-css-outlined-input"
            size="small"
            sx={{ width: "90%", mb: "2%" }}
            value={pgDegree}
            onChange={(e) => setPgDegree(e.target.value)}
          />
        </Box>

        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
        >
          <Button
            type="button"
            className="btn btn-sm rounded-2 fw-medium"
            onClick={clearForm}
            sx={{
              border: "1px solid",
              color: "#033538",
              width: "120px",
              height: "35px",
              borderRadius: "10px",
              marginRight: "2%",
            }}
          >
            Clear
          </Button>

          <Button
            type="submit"
            className="btn btn-sm rounded-2 fw-medium"
            sx={{
              border: "1px solid",
              color: "white",
              width: "120px",
              height: "35px",
              borderRadius: "10px",
              backgroundColor: "#033538",
            }}
            onClick={(e) => saveJobDetails(e)}
          >
            Submit
          </Button>
        </Box>

        <br />
        <br />
        <br />
        <br />
        <br />
      </Box>
    </div>
  );
};
export default JobDescription;